YP.WidgetPro = function() {

    var tab__item = $('.js-tab-widget .js-tab-widget__item');
    var btn__copy = $('.js-widget__copy-btn');

    return {
        init: function() {
            if(tab__item.length > 0){
                tab__item.on("click", this.switchDesignCode);
            }
            if(btn__copy.length > 0){
                btn__copy.on("click", this.copyCode);
            }
        },
        switchDesignCode: function(event){
            $('.js-tab-widget .js-tab-widget__item').each(function(){
                $(this).removeClass('is-active');
            })

            $(this).addClass('is-active');

            if($(this).hasClass('js-tab-widget__item_code')){
                $('.js-tab-widget__show_code').show();
                $('.js-tab-widget__show_design').hide();
            }
            else{
                $('.js-tab-widget__show_code').hide();
                $('.js-tab-widget__show_design').show();
            }
        },
        copyCode: function(event){

            $('.js-widget__copy-zone').select();
            document.execCommand('copy');

            if ( document.execCommand( 'copy' ) ) {
                $('.js-widget__copy-success').addClass('u-show');

                var temp = setInterval( function(){
                  $('.js-widget__copy-success').removeClass('u-show');
                  clearInterval(temp);
                }, 6000 );

            }
            else {
                $('.js-widget__copy-fail').addClass('u-show');

                var temp = setInterval( function(){
                  $('.js-widget__copy-fail').removeClass('u-show');
                  clearInterval(temp);
                }, 10000 );
            }

            return false;
        },
    }
}

window.addEventListener("load", function(){
    YP.WidgetPro().init();
});
